import { render, staticRenderFns } from "./LandparcelPriceBI.vue?vue&type=template&id=774cb5c6&lang=html&"
import script from "./LandparcelPriceBI.vue?vue&type=script&lang=js&"
export * from "./LandparcelPriceBI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports